module.exports = __webpack_public_path__ + "static/match-1eff6202ec088d5e9431c333db68474b.mp3";